import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store-old'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import firebase from 'firebase'
import 'firebase/firestore'
import { firebaseSettings } from './config/firebaseSetting'
import VueGeolocation from 'vue-browser-geolocation'
import JsonExcel from 'vue-json-excel'
import * as VueGoogleMaps from 'gmap-vue'
import VueApexCharts from 'vue-apexcharts'

Vue.use(VueApexCharts)
Vue.component('downloadExcel', JsonExcel)
Vue.use(VueGeolocation)

Vue.component('apexchart', VueApexCharts)

firebase.initializeApp(firebaseSettings)
export const db = firebase.firestore()
Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAn_bqJvKg6qI2gcbZ5N6RpjiuyiiZKUAo',
  },
  installComponents: true,
})

let app

firebase.auth().onAuthStateChanged(async (firebaseUser) => {
  if (firebaseUser) {
    await store.dispatch('autoSignIn', firebaseUser)
  } else {
    localStorage.removeItem('userAuth')
  }

  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      i18n,
      render: h => h(App),
    }).$mount('#app')
  }
})
